import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AvisoLegalService {
  private shownParaPublico = false;
  private shownParaAutenticado = false;

  hasShownParaPublico(): boolean {
    return this.shownParaPublico;
  }

  hasShownParaAutenticado(): boolean {
    return this.shownParaAutenticado;
  }

  setShownParaPublico(): void {
    this.shownParaPublico = true;
  }

  setShownParaAutenticado(): void {
    this.shownParaAutenticado = true;
  }
}
